import React from "react";
import Footer from "./Footer";
import Navbar from "./Navbar";
import ReactTooltip from "react-tooltip";
import { useEffect, useState } from "react";
const Product = () => {
  const [product, setProduct] = React.useState([]);
  const [allproduct, setAllProduct] = React.useState([]);
  const [search, setSearch] = useState("");
  const deleteProduct = (id) => {
    try {
      fetch(
        process.env.REACT_APP_SERVER_URL + `/inventory/deleteProductAdmin`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ id }),
        }
      )
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          // loadData()
          loadProductList();
        })
        .catch((err) => console.log(err));
    } catch (error) {
      console.log(error);
    }
  };

  const loadProductList = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_SERVER_URL + "/Inventory/getAllProduct",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      const data = await response.json();
      console.log(data);
      setProduct(data.allProduct);
    } catch (err) {
      console.log(err);
    }
  };
   
  useEffect(() => {
    setAllProduct(product);
    if (search !== "") {
      let filteredBuyers = product.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
      );
      setAllProduct(filteredBuyers);
      // loadProductList();
    } else {
      setAllProduct(product);
      // loadProductList();
    }
  }, [search, product]);

  React.useEffect(() => {
    loadProductList();
  }, []);

  return (
    <div>
      <Navbar />
      <div
        className="text-3xl w-full font-bold bg-gradient-to-l from-green-200 to-green-500"
        style={{ textAlign: "center" }}
      >
        <p className="pt-2">Product</p>
      </div>
      <div className=" flex flex-row items-center">
        <div className="m-2 mt-8 bg-slate-500 px-3 py-1 text-green-400 rounded-2xl font-bold">
          Search
        </div>
        <input
          type="text"
          placeholder="      Product Name"
          className="mt-5 ml-3 dark:bg-black dark:text-white bg-gray-200 border border-gray-400 rounded-2xl py-2 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-green-600 focus:border-transparent"
          onChange={(e) => {
            setSearch(e.target.value);
          }}
        />
      </div>
      <section className="min-h-screen">
        <div className="overflow-x-auto relative shadow-md sm:rounded-lg text-center">
        <h3 className='w-full text-center'>Total Product : {product.length}</h3>
          <table className="w-full text-sm  text-gray-500 dark:text-gray-400 container mx-auto mt-10 text-center">
            <thead className="text-xs text-gray-700 uppercase bg-gray-200 dark:text-gray-400">
              <tr>
                <th scope="col" className="py-3 px-6">
                  Image
                </th>
                <th scope="col" className="py-3 px-6">
                  Name
                </th>
                <th scope="col" className="py-3 px-6">
                  Description
                </th>
                <th scope="col" className="py-3 px-6">
                  Cost Per Unit
                </th>
                <th scope="col" className="py-3 px-6">
                  Quantity
                </th>
                <th scope="col" className="py-3 px-6">
                  Status
                </th>
                <th scope="col" className="py-3 px-6">
                  Discount
                </th>
                <th scope="col" className="py-3 px-6">
                  Type
                </th>
                <th scope="col" className="py-3 px-6">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {allproduct.length > 0 ? (
                allproduct.map((item, index) => {
                  return (
                    <tr
                      key={index}
                      className="border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800"
                    >
                      <td className="py-4 px-6">
                        <img
                          src={item.imgUrl}
                          style={{ width: "10.2rem" }}
                          alt="..."
                        />
                      </td>
                      <td className="py-4 px-2 font-bold mx-auto">
                        {item.name}
                      </td>
                      {item.description.length > 20 ? (
                        <td className="py-4 px-6 font-bold mx-auto">
                          <button
                            data-tip={item.description}
                            data-for={`tooltip-${item._id}`}
                          >
                            {item.description.length > 20
                              ? item.description.substring(0, 20) + "..."
                              : item.description}
                          </button>
                          <ReactTooltip
                            id={`tooltip-${item._id}`}
                            type="info"
                            effect="solid"
                            place="bottom"
                            className="w-40 h-50"
                          >
                            <span>{item.description}</span>
                          </ReactTooltip>
                        </td>
                      ) : (
                        <td className="py-4 px-6 font-bold mx-auto">
                          {item.description}
                        </td>
                      )}

                      <td className="py-4 px-6 font-bold mx-auto">
                        {item.cost_per_unit}
                      </td>
                      <td className="py-4 px-6 font-bold mx-auto">
                        {item.quantity}
                      </td>
                      {item.status === "Out of Stock" ? (
                        <td className="py-4 px-6 font-bold mx-auto text-red-900">
                          {item.status}
                        </td>
                      ) : (
                        <td className="py-4 px-6 font-bold mx-auto text-green-600">
                          {item.status}
                        </td>
                      )}

                      <td className="py-4 px-6 font-bold mx-auto">
                        {item.discount}
                      </td>
                      <td className="py-4 px-6 font-bold mx-auto">
                        {item.type}
                      </td>
                      <td className="py-4 px-6  ">
                        <button
                          onClick={() => {
                            deleteProduct(item._id);
                          }}
                          className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="10" className="py-3 px-6">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Product;
